import React from 'react';
import { ScrollView } from 'react-native';
import {
  Modal, Portal, Text, Button, Title,
} from 'react-native-paper';
import { appColors } from '../../assets/styles/global';
import { pixelDimensions } from '../../config/utils';

export default function ModalAgreement({
  agreement, visible, onDismiss, title, textButton = 'OK',
}) {
  const containerStyle = { backgroundColor: 'white' };
  return (
    <Portal>
      <Modal visible={visible} onDismiss={onDismiss} contentContainerStyle={containerStyle}>
        <Title style={{ alignSelf: 'center' }}>{title}</Title>
        <ScrollView>
          <Text style={{ alignSelf: 'center', padding: pixelDimensions(2) }}>{agreement}</Text>
        </ScrollView>
        <Button
          mode="contained"
          onPress={onDismiss}
          style={{ marginBottom: pixelDimensions(2), backgroundColor: appColors.primary }}
        >
          {textButton}
        </Button>
      </Modal>
    </Portal>
  );
}
